import axios, { AxiosError } from "axios";

export const getErrorMessage = (err: Error | AxiosError, text?: string): string => {
    const errText = fromError(err);
    if (text) {
        return `${text} ${errText}`;
    }
    return errText;
}

const fromError = (err: Error | AxiosError): string => {
    if (axios.isAxiosError(err)) {
        const data = err.response?.data;
        if (data && typeof data === 'object') {
            return data.message || data.error || JSON.stringify(data);
        }
        if (typeof data === 'string') {
            return data;
        }
        if (err.request) {
            return "Błąd połączenia z serwerem.";
        }
    }
    return err instanceof Error ? err?.message : "Wystąpił nieoczekiwany błąd.";
}
